<template>
    <paper id="agingProduct">
        <m-pane
            ref="tablePage"
            :config="config"
            :totalData="totalData"
            :pageTotal="pageTotal"
            :loading="loading"
            :initSearchInfo="initSearchInfo"
            @saveData="saveData"
            @row-db-click="rowDBclick"
            @check-btn="checkBtn"
            @edit-btn="editBtn"
            @switch-change="switchChange"
            @selectChange="selectChange"
            @searchChange="searchChange"
            @pageChange="pageChange"
            @sizeChange="sizeChange"
            searchId="inTransitTracking_query"
            pageID="inTransitTracking"
            class="in-transit-tracking">
            <div slot="table-module-btn">
                <el-tooltip effect="dark" content="导出" placement="bottom">
                    <span v-has="'otp04130001'">
                        <el-button icon="icon-daochu" size="mini" @click="handleExport()"></el-button>
                    </span>
                </el-tooltip>
            </div>
        </m-pane>
    </paper>
</template>
<script>
import dayjs from 'dayjs';
import mPane from '@/components/otpPanel';
import config from './config.json';
import paper from '@/components/core/paper/Paper';
import { getTracking, exportListData } from '../../../api/inTransitTracking';
import { dateTimes } from '../../../judge/configCenter';
export default {
    name: 'inTransitTrackings',
    components: { mPane, paper },
    data() {
        return {
            config: config,
            totalData: [],
            loading: false,
            pageTotal: 0,
            searchParams: {
                pageSize: 10,
                pageNo: 1
            },
            initSearchInfo: {},
            isFirstSearch: true
        };
    },
    methods: {
        handleExport() {
            const isFirstSearch = this.isFirstSearch;
            // 第一次点导出时触发查询函数，之后的导出以前一次的查询条件为准
            this.isFirstSearch && this.$refs.tablePage.$refs.searchList.onSearchChange();
            if (this._validateSearchParams()) return isFirstSearch ? false : this.$message.warning(this._validateSearchParams());
            this.$confirm('是否确定导出?', '导出确认', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                this.isFirstSearch = false;
                const param = this.searchParams;
                delete param.pageSize;
                delete param.pageNo;
                delete param.customerName;
                delete param.siteName;
                exportListData(param).then(res => {
                    if (res) {
                        this.$message.success(res.data);
                    }
                });
            });
        },
        _validateSearchParams() {
            const startTime = this.searchParams.startTime || 0;
            const endTime = this.searchParams.endTime || 0;
            const timeDifference = new Date(endTime).getTime() - new Date(startTime).getTime();
            if (!this.searchParams.customerId || !startTime) {
                return '客户 和 创建时间 不可为空';
            } else if (timeDifference > 3 * 24 * 60 * 60 * 1000) {
                return '按时间查询时，查询/导出 时间跨度不可超过三天！';
            }
        },
        async getList(searchCountFlag) {
            if (this._validateSearchParams()) return this.$message.warning(this._validateSearchParams());
            this.isFirstSearch = false;
            this.loading = true;
            const res = await getTracking(this.searchParams);
            if (res) {
                this.loading = false;
                this.totalData = res.data.list || [];
                this.pageTotal = res.data.totalCount;
            }
        },
        rowDBclick(row) {
            // 表格内双击事件
        },
        checkBtn(data) {
            // 表格内按钮查看事件;
            this.visible = true;
        },
        editBtn(data) {
            // 表格内按钮修改事件;
        },
        selectChange(data) {
            // 表格内选择变化
            this.selectRow = data;
        },
        switchChange(data) {
            // 表格内switch切换事件
        },
        searchChange(data) {
            // 提交搜索框
            if (data.time) {
                data.startTime = dateTimes(data.time[0]) || '';
                data.endTime = dateTimes(data.time[1]) || '';
            }
            delete data.time;

            delete data.itemName;
            this.searchParams = { ...data, pageNo: 1, pageSize: this.searchParams.pageSize };
            this.getList();
        },
        pageChange(data) {
            // 分页器页数变化
            this.searchParams.pageNo = data;
            this.getList(true);
        },
        sizeChange(data) {
            // 分页器页数大小变化
            this.searchParams.pageSize = data;
            this.getList(true);
        },
        addData() {
            // 表格新增方法
            this.$refs.tablePage.$refs.table.addRow();
        },
        saveData(data) {
            // 表格新增修改后返回数据
        },
        redomet(data) {
            // 这是删除方法
        },
        refresh() {
            // 表格内刷新按钮
        },
        init() {
            const initSearchInfo = {};
            const startTime = dayjs()
                .subtract(2, 'days')
                .startOf('day');
            const endTime = dayjs().endOf('day');
            initSearchInfo.time = [startTime.toDate(), endTime.toDate()];
            this.initSearchInfo = initSearchInfo;
        }
    },
    mounted() {
        // this.getList();
        this.init();
    }
};
</script>
